var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-block",class:{ 'is-active': _vm.isActive, 'is-created': _vm.isCreated },on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeAllOverlayProcesses($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }